module.exports = __webpack_public_path__ + "img/lingqu.6bebec8f.png";